






























import { computed, defineComponent, ref } from "@vue/composition-api";
import { UserVerificationStatus } from "@scrile/api-provider/dist/api/UserVerificationProvider";
import useAuthUser from "@/hooks/useAuthUser";
import useUserVerification from "@/hooks/useUserVerification";
import config from "@/config";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BasePage from "@/components/BasePage";
import PayeeInfoSetupView from "./components/PayeeInfoSetupView.vue";
import PayeeInfoView from "./components/PayeeInfoView.vue";

export default defineComponent({
  name: "PagePayeeInfo",
  components: { PayeeInfoView, PayeeInfoSetupView, BasePage, BaseConfirm, BaseButton },
  setup() {
    const showContractConfirm = ref(false);

    const { userVerificationFindMyStatus } = useUserVerification();
    const { userVerificationStatus } = useAuthUser();

    const showSetup = computed(() => userVerificationStatus.value === UserVerificationStatus.UNVERIFIED);
    const creatorContractUrl = computed(() => config.creatorContractUrl);

    const getData = async () => {
      await userVerificationFindMyStatus();
    };

    getData();

    return {
      showSetup,
      creatorContractUrl,
      showContractConfirm,
    };
  },
});
